import { getExcelTemplateExportService, uploadExcelVOC, upsertCustomerFeedback } from "features/journey-map/reducer/CJMActions";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { getStageCustomerFeedback } from "redux/memoizedSelectors";
import { FlexJustifyStart, GenericButton, IconDispatcher, Label } from "shared/ui-basics/index";
import { UploadFile } from "../UploadFile";
import { FeedBackData, WrapperInfo } from "./FeedBackData";

//handleUpsertFeedbacks ->if we get value =0 this mean the user want to clean the cxMetrics to null;
export const ImportFile = ({ feedback, isViewer, onClose }) => {
	const { t } = useTranslation();
	const { cjmIdStr: cjmId,personaIdStr } = useLocation()?.search.getMapsParams();
	const currentItem = useSelector(getStageCustomerFeedback(feedback.stageId, personaIdStr))?.getById(feedback.id) || [];
	const fileUploadRef = useRef(null);

	const [isHaveFile, setIsFile] = useState(false);
	const [validFile, setValidFile] = useState(true);
	const [errorFile, setErrorFile] = useState("");


	const isDisable = isViewer || (currentItem?.retrieveData);
	const isDisableRetrieveData = !isHaveFile || (currentItem?.retrieveData && !currentItem?.stopRetrieveData)

	const onFailed = (msg) => {
		if (msg?.response?.data)
			setErrorFile(t(msg?.response?.data).replace("{NUB_LIMIT}", 10000));
		setValidFile(false);
		setIsFile(false);
	}
	const onSuccessImport = () => {
		upsertCustomerFeedback({ customerFeedback: { ...currentItem, retrieveData: true, stopRetrieveData: true, errorMsg: "" }, cjmId: cjmId })
		toast.info(t("IMPORT_DATA_IN_PROGRESS"));
		onClose();
	}
	const startCreateData = () => {
		if (fileUploadRef.current) {
			const authorizedExtenions = ["xlsx"];
			const files = fileUploadRef.current.getFiles();
			if (files?.length > 0) {
				const file = files[0];
				const fileExtension = file?.name?.split(".")?.pop()?.toLowerCase();
				if (authorizedExtenions.indexOf(fileExtension) == -1) {
					setValidFile(false);
					setErrorFile(t("EXCEL_NOT_VALID"));
					return;
				}
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onloadend = function () {
					const base64data = reader.result;
					uploadExcelVOC({ customerFeedback: feedback, fileBody64: base64data.split(",")[1], cjmId, onFailed: onFailed, onSuccess: onSuccessImport });
				};
			}
		}
	};


	return (
		<>
			<Row className="pt-4">
				<UploadFile fileUploadRef={fileUploadRef} isDisable={isDisable} setValidFile={setValidFile}
					stopRetrieveData={currentItem?.stopRetrieveData} setIsFile={setIsFile} templateExportService={getExcelTemplateExportService} />
			</Row>
			{(!validFile || (currentItem?.errorMsg && !currentItem?.errorMsg?.isEmptyString())) &&
				<WrapperInfo type="error" className="mt-2">
					<div>{IconDispatcher("triangle-exclamation", "", { style: "solid", color: "#D50000" })}</div>
					<Label size={12} color="#D50000">{t("ERROR")} :
						{!errorFile?.isEmptyString() ? errorFile : !currentItem?.errorMsg?.isEmptyString() ? currentItem?.errorMsg : ""}
					</Label>
				</WrapperInfo>}
			<FlexJustifyStart className=" pt-4">
				<GenericButton variant="dark" disabled={isDisableRetrieveData} onClick={startCreateData}>
					{t("START_RETRIEVE_DATA")}
				</GenericButton>
			</FlexJustifyStart>
			{currentItem?.customerFeedbackDatas?.length > 0 && <FeedBackData feedback={currentItem} showStopRetrieveData={false} />}
		</>
	);
};
export default ImportFile;

ImportFile.propTypes = {
	feedback: PropTypes.shape({
		stopRetrieveData: PropTypes.bool,
		touchPointId: PropTypes.string,
		cxMetricsId: PropTypes.string,
		retrieveData: PropTypes.bool,
		id: PropTypes.string,
	}),
	stageId: PropTypes.string,
	isViewer: PropTypes.bool,
};

